/** Config EmptyShelves */
export const apiBase = "https://api.bookteriors.com/v1/";
export const loginPageEmail = "projects@bookteriors.com";
export const loginPageLogo = "BOOKT/logo_login.png";
export const loginPageBanner = "BOOKT/login_banner.jpg";
export const homePageLogo = "BOOKT/logo_home.png";
export const favicon = "BOOKT/favicon.ico";
export const documentTitle = "BOOKTERIORS";
export const logoWidth = 250;
export const socketIOServerAdd = "https://api.bookteriors.com";

//** To make it available for all the users, leave forTeams=[] blank */
export const winnersMap = [
  {
    conditions: {
      module: "",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "REJECT",
      bgColor: "#F20050",
      textColor: "#FFFFFF",
      sound: "audioReject",
    },
  },
  {
    conditions: {
      module: "MARKETPLACE",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "MARKETPLACE",
      bgColor: "#D1859A",
      textColor: "#FFFFFF",
      sound: "audioFBA",
    },
  },
  {
    conditions: {
      module: "AMAZON",
      subModule: "FBA",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "FBA",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioFBA",
    },
  },

  {
    conditions: {
      module: "AMAZON",
      subModule: "MF",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "MF",
      bgColor: "#F4874B",
      textColor: "#FFFFFF",
      sound: "audioMF",
    },
  },
  {
    conditions: {
      module: "AMAZON NEW",
      subModule: "FBA",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "FBA-NEW",
      bgColor: "#00743f",
      textColor: "#FFFFFF",
      sound: "audioFBANew",
    },
  },
  {
    conditions: {
      module: "AMAZON NEW",
      subModule: "MF",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "MF-NEW",
      bgColor: "#F4874B",
      textColor: "#FFFFFF",
      sound: "audioMFNew",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "SBYB",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "SBYB",
      bgColor: "#6a8a82",
      textColor: "#FFFFFF",
      sound: "audioSBYB",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "RMS",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "RMS",
      bgColor: "#fbbc04",
      textColor: "#FFFFFF",
      sound: "audioRMS",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "BR",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "BOOKSRUN",
      bgColor: "#0D3C55",
      textColor: "#FFFFFF",
      sound: "audioBR",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "BRB",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "BLUE ROCKET BOOKS",
      bgColor: "#212323",
      textColor: "#FFFFFF",
      sound: "audioBRB",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "SB",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "SELLBOOKS",
      bgColor: "#72a2c0",
      textColor: "#FFFFFF",
      sound: "audioSB",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "ZIFFIT",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "ZIFFIT",
      bgColor: "#0444bf",
      textColor: "#FFFFFF",
      sound: "audioZIFFIT",
    },
  },
  {
    conditions: {
      module: "WHOLESALE",
      subModule: "UBB",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "UBB",
      bgColor: "#474749",
      textColor: "#FFFFFF",
      sound: "audioUBB",
    },
  },
  {
    conditions: {
      module: "BOOKSCOUTER",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "BS: [SUB_MODULE]",
      bgColor: "#a37c27",
      textColor: "#FFFFFF",
      sound: "audioBS",
    },
  },
  {
    conditions: {
      module: "BOOKSTORE",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "[SUB_MODULE]",
      bgColor: "#6465A5",
      textColor: "#FFFFFF",
      sound: "audioWS",
    },
  },
  {
    conditions: {
      module: "HITLIST",
      subModule: "",
      forTeams: [],
      excludeTeams: [],
    },
    display: {
      name: "[SUB_MODULE]",
      bgColor: "#040c0e",
      textColor: "#FFFFFF",
      sound: "audioHitList",
    },
  },
];
